// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 基础框架依赖
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * UI组件库
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// Ant Design Vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// Antdv扩展库
import antdvLibs from 'antdv-libs'
import 'antdv-libs/lib/AntdvLibs.css'

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 可视化库
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
import * as echarts from 'echarts'

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 富文本编辑器
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 本地依赖
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
import config from './common/config'
import * as common from './common'
import * as apis from './apis'

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 样式资源
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
import './style/theme.less'
import './style/global.css'
import './style/base.css'
import "@/assets/iconfont/fonts.css";

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 全局配置
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
// 生产环境提示
Vue.config.productionTip = false

// UI组件注册
Vue.use(ElementUI)
Vue.use(Antd)
Vue.use(antdvLibs, { settings: config })
Vue.use(VueQuillEditor)

// 全局组件注册

// 原型链扩展
Vue.prototype.$common = common
Vue.prototype.$apis = apis
Vue.prototype.$echarts = echarts

// /​**​*​**​*​**​*​**​*​**​*​**​*​**​*
//  * 应用初始化
//  ​**​*​**​*​**​*​**​*​**​*​**​*​**​*/
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')